module.exports=﻿{
    "config": [
        {
            "persona": "_connected",
            "states": [ 
                {
                    "current": "tunnel-ctr-connected.beneficiaire",
                    "next": "tunnel-ctr-connected.recapitulatif",
                    "previous": null
                },
                {
                    "current": "tunnel-ctr-connected.recapitulatif",
                    "next": "tunnel-ctr-connected.confirmation",
                    "previous": "tunnel-ctr-connected.beneficiaire"
                },
                {
                    "current": "tunnel-ctr-connected.confirmation",
                    "next": null,
                    "previous": "tunnel-ctr-connected.recapitulatif"
                }
            ]
        },
        {
            "persona": "_defaults",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.persona",
                    "previous": null
                },
                {
                    "current": "tunnel-ctr.persona",
                    "next": null,
                    "previous": "tunnel-ctr-intro"
                }
            ]
        },
        {
            "persona": "Directeur",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": "tunnel-ctr.prestations",
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.prestations",
                    "next": "tunnel-ctr.siret-devis",
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.siret-devis",
                    "next": "tunnel-ctr.coordonnees",
                    "previous": "tunnel-ctr.prestations",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.coordonnees",
                    "next": "tunnel-ctr.recapitulatif",
                    "previous": "tunnel-ctr.siret-devis",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.recapitulatif",
                    "next": null,
                    "previous": "tunnel-ctr.coordonnees",
                    "onlyConnectedUser": false
                }
            ]
        },
        {
            "persona": "Secrétaire",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": "tunnel-ctr.prestations",
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.prestations",
                    "next": "tunnel-ctr.siret-devis",
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.siret-devis",
                    "next": "tunnel-ctr.coordonnees",
                    "previous": "tunnel-ctr.prestations",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.coordonnees",
                    "next": "tunnel-ctr.recapitulatif",
                    "previous": "tunnel-ctr.siret-devis",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.recapitulatif",
                    "next": null,
                    "previous": "tunnel-ctr.coordonnees",
                    "onlyConnectedUser": false
                }
            ]
        },
        {
            "persona": "Assistant",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": "tunnel-ctr.prestations",
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.prestations",
                    "next": "tunnel-ctr.siret-devis",
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.siret-devis",
                    "next": "tunnel-ctr.coordonnees",
                    "previous": "tunnel-ctr.prestations",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.coordonnees",
                    "next": "tunnel-ctr.recapitulatif",
                    "previous": "tunnel-ctr.siret-devis",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.recapitulatif",
                    "next": null,
                    "previous": "tunnel-ctr.coordonnees",
                    "onlyConnectedUser": false
                }
            ]
        },
        {
            "persona": "Comptable",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": "tunnel-ctr.prestations",
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.prestations",
                    "next": "tunnel-ctr.siret-devis",
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.siret-devis",
                    "next": "tunnel-ctr.coordonnees",
                    "previous": "tunnel-ctr.prestations",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.coordonnees",
                    "next": "tunnel-ctr.recapitulatif",
                    "previous": "tunnel-ctr.siret-devis",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.recapitulatif",
                    "next": null,
                    "previous": "tunnel-ctr.coordonnees",
                    "onlyConnectedUser": false
                }
            ]
        },
        {
            "persona": "Gérant",
            "states": [
                {
                    "current": "tunnel-ctr-intro",
                    "next": "tunnel-ctr.simulation",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.simulation",
                    "next": "tunnel-ctr.prestations",
                    "previous": "tunnel-ctr-intro",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.prestations",
                    "next": "tunnel-ctr.siret-devis",
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.siret-devis",
                    "next": "tunnel-ctr.coordonnees",
                    "previous": "tunnel-ctr.prestations",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.coordonnees",
                    "next": "tunnel-ctr.recapitulatif",
                    "previous": "tunnel-ctr.siret-devis",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.recapitulatif",
                    "next": null,
                    "previous": "tunnel-ctr.coordonnees",
                    "onlyConnectedUser": false
                }
            ]
        },
        {
            "persona": "Autre",
            "states": [
                {
                    "current": "tunnel-ctr.simulation",
                    "next": "tunnel-ctr.prestations",
                    "previous": null,
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.prestations",
                    "next": "tunnel-ctr.siret-devis",
                    "previous": "tunnel-ctr.simulation",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.siret-devis",
                    "next": "tunnel-ctr.coordonnees",
                    "previous": "tunnel-ctr.prestations",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.coordonnees",
                    "next": "tunnel-ctr.recapitulatif",
                    "previous": "tunnel-ctr.siret-devis",
                    "onlyConnectedUser": false
                },
                {
                    "current": "tunnel-ctr.recapitulatif",
                    "next": null,
                    "previous": "tunnel-ctr.coordonnees",
                    "onlyConnectedUser": false
                }
            ]
        }
    ]
}
